import { Muscle, PagedResponse } from '../../types';
import { getDataWithRetry, mapPagedResult } from '../fetchUtils';
import { isValidMuscleGroupResponse } from '../apiValidators';
import { apiBaseUrl } from '../apiConsts';

import type { FetchResult } from '../fetchUtils';

export const getMuscles = async (): Promise<FetchResult<Muscle[]>> => {
  const response = await getDataWithRetry<PagedResponse<Muscle>>(
    `${apiBaseUrl}muscles?page=0&size=1000&sort=name`,
    {},
    isValidMuscleGroupResponse,
  );
  return mapPagedResult(response);
};
